import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const adminHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
});

export const fetchHotelOwnerAccess = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/admin/hotel-owner-access`, {
    headers: adminHeaders(),
  });
  return Array.isArray(data) ? data : [];
};

export const saveHotelOwnerAccess = async (payload) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/admin/hotel-owner-access`, payload, {
    headers: adminHeaders(),
  });
  return data;
};

export const deleteHotelOwnerAccess = async (id) => {
  await axios.delete(`${API_BASE_URL}/api/admin/hotel-owner-access/${id}`, {
    headers: adminHeaders(),
  });
};

export const loginHotelOwner = async (accessKey) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/hotel-owner/${accessKey}/login`);
  return data;
};

export const fetchOwnerHotelAvailability = async (accessKey, token, startDate, endDate) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/hotel-owner/${accessKey}/availability`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { startDate, endDate, _: Date.now() },
  });
  return Array.isArray(data) ? data : [];
};

export const fetchOwnerHotelBookings = async (accessKey, token) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/hotel-owner/${accessKey}/bookings`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { _: Date.now() },
  });
  return Array.isArray(data) ? data : [];
};

// How far back the Completed tab reaches, so the portal can say where older trips went.
export const fetchOwnerBookingVisibility = async (accessKey, token) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/hotel-owner/${accessKey}/bookings/visibility`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { _: Date.now() },
  });
  return data || {};
};

// The hotel accepts a booking from its portal - the same acceptance as the WhatsApp link. `proof`
// is the accepter's name and location, which the server requires.
export const acceptOwnerBooking = async (accessKey, token, bookingId, hotelId, proof) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/hotel-owner/${accessKey}/bookings/${bookingId}/hotels/${hotelId}/accept`,
    proof,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
};

export const updateOwnerHotelAvailability = async (accessKey, token, payload) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/hotel-owner/${accessKey}/availability`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return Array.isArray(data) ? data : [];
};

// Rooms Iotrips is holding at this portal's hotels. The hotel can see and accept them, not release them.
export const fetchOwnerRoomHolds = async (accessKey, token) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/hotel-owner/${accessKey}/holds`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { _: Date.now() },
  });
  return Array.isArray(data) ? data : [];
};

export const acceptOwnerRoomHold = async (accessKey, token, holdId, proof) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/hotel-owner/${accessKey}/holds/${holdId}/accept`,
    proof,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
};

export const markOwnerHotelSoldOut = async (accessKey, token, payload) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/hotel-owner/${accessKey}/availability/hotel-sold-out`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return Array.isArray(data) ? data : [];
};

export const undoOwnerHotelSoldOut = async (accessKey, token, payload) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/hotel-owner/${accessKey}/availability/hotel-sold-out/undo`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return Array.isArray(data) ? data : [];
};
